import { getLikedAudioIdsUrl } from '@core/api'
import { httpClient } from '@core/http-client'

export const getLikedAudioIds = async (signal?: AbortSignal) => {
    const apiResponse = await httpClient
        .get(getLikedAudioIdsUrl(), {
            signal,
        })
        .json<{ liked_audio: string[] }>()

    return apiResponse.liked_audio
}
